import React, { useState } from "react"
import { RichText, RichTextBlock } from "prismic-reactjs"

import { Text } from "../../Text/Text"


interface OwnProps {
  questions: {
    question: string;
    answer: {
      richText: RichTextBlock,
      text: string
    }
  }[]
}

export type FaqQuestionsProps = OwnProps

export const FaqQuestions: React.FC<FaqQuestionsProps> = ({
  questions
}) => {
  const [ toggle, setToggle ] = useState({});

  const toggleFunction = (id): void => {
    setToggle({
      ...toggle,
      [id]: !toggle[id],
    });
  }

  return (    
    <div className="my-15 md:my-7">
      {questions.map((item, index) => {
        return (
          <div className="pt-7 mt-7 border-t first:pt-0 first:md:mt-0 first:border-t-0" key={index}>
            <div className="relative pr-8 overflow-hidden">
              <Text variant="small-subheader">{item.question}</Text>
              <div className={`transtion duration-500 ease-in-out mt-7 [&_a]:underline ${toggle[`location-${index}`] ? "max-h-[1000px]" : "max-h-0"}`}>
                {item.answer?.richText && (<Text variant="body"><RichText render={item.answer?.richText} /></Text>)}
              </div>
              <div 
                className={`absolute top-0 right-0 inline-block border border-turquoise w-8 h-8 rounded-full leading-8 text-[24px] text-center text-turquoise cursor-pointer ${toggle[`location-${index}`] ? "rotate-45" : "rotate-0"}`}
                onClick={() => toggleFunction(`location-${index}`)}
              >
                <span className="sr-only">Toggle</span> +
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
